import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Star(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 24 24">
      <path d="M12 0l3.523 8.17L24 9.167l-6.301 6.045L19.416 24 12 19.567 4.584 24l1.717-8.787L0 9.168l8.477-.999z"></path>
    </IconSvg>
  );
}
